import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../common/hooks/useAuth';
import Button from '../../common/components/Button';
import Input from '../../common/components/Input';
import Card from '../../common/components/Card';
import toast from 'react-hot-toast';
import './LoginScreen.css';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
        toast.success('Login successful!');
      } else {
        await register(email, password);
        toast.success('Account created successfully!');
      }
      navigate('/', { replace: true });
    } catch (error) {
      toast.error(error.message || 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-header">
          <h1>Farm First Producers</h1>
          <p>Manage your farm products and inventory</p>
        </div>
        <Card>
          <form onSubmit={handleSubmit}>
            <h2>{isLogin ? 'Login' : 'Create Account'}</h2>
            <Input
              label="Email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
            <Input
              label="Password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
            <Button type="submit" loading={loading} size="large" style={{ width: '100%' }}>
              {isLogin ? 'Login' : 'Create Account'}
            </Button>
            <div className="toggle-auth">
              {isLogin ? "Don't have an account? " : 'Already have an account? '}
              <button
                type="button"
                className="link-button"
                onClick={() => setIsLogin(!isLogin)}
              >
                {isLogin ? 'Create one' : 'Login'}
              </button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default LoginScreen;
